import * as THREE from "three";
import { squareToWorld } from "./boardCoordinates";
import type { Settings } from "../app/Settings";

export class TourPath3D {
  readonly group = new THREE.Group();
  private trail = new THREE.Line(new THREE.BufferGeometry(), new THREE.LineBasicMaterial({ color: 0xf2c14e, transparent: true, opacity: .95 }));
  private full = new THREE.Line(new THREE.BufferGeometry(), new THREE.LineBasicMaterial({ color: 0xf6e7b0, transparent: true, opacity: .28 }));
  private closing = new THREE.Line(new THREE.BufferGeometry(), new THREE.LineDashedMaterial({ color: 0xe66a4e, dashSize: .13, gapSize: .09, transparent: true, opacity: .9 }));
  private labels = new THREE.Group();
  private tour: number[] = [];
  private isClosed = false;
  constructor(private settings: Settings) { this.group.add(this.full, this.trail, this.closing, this.labels); }
  setTour(tour: number[], closed: boolean): void {
    this.tour = tour.slice(); this.isClosed = closed; this.setGeometry(this.full, tour);
    this.closing.visible = closed;
    if (closed && tour.length > 1) { this.setGeometry(this.closing, [tour[tour.length - 1], tour[0]]); this.closing.computeLineDistances(); }
    this.rebuildLabels(); this.update(1);
  }
  update(visited: number): void {
    this.setGeometry(this.trail, this.tour.slice(0, Math.max(1, visited)));
    this.full.visible = this.settings.pathMode === "full";
    this.trail.visible = this.settings.pathMode !== "off";
    this.closing.visible = this.isClosed && this.settings.pathMode === "full";
    this.labels.visible = this.settings.showMoveNumbers;
  }
  private setGeometry(line: THREE.Line, squares: number[]): void { line.geometry.dispose(); line.geometry = new THREE.BufferGeometry().setFromPoints(squares.map(s => squareToWorld(s, .08))); }
  private rebuildLabels(): void {
    for (const child of [...this.labels.children]) { const s = child as THREE.Sprite; s.material.map?.dispose(); s.material.dispose(); this.labels.remove(s); }
    this.tour.forEach((square, i) => {
      const canvas = document.createElement("canvas"); canvas.width = 64; canvas.height = 64; const c = canvas.getContext("2d")!;
      c.fillStyle = "rgba(8,18,18,.82)"; c.beginPath(); c.arc(32,32,20,0,Math.PI*2); c.fill(); c.fillStyle = "#fff7dc"; c.font = "bold 24px system-ui"; c.textAlign="center"; c.textBaseline="middle"; c.fillText(String(i + 1),32,33);
      const texture = new THREE.CanvasTexture(canvas); const sprite = new THREE.Sprite(new THREE.SpriteMaterial({ map: texture, depthTest: false })); sprite.scale.set(.3,.3,.3); sprite.position.copy(squareToWorld(square,.16)); this.labels.add(sprite);
    });
  }
  dispose(): void { this.full.geometry.dispose(); this.trail.geometry.dispose(); this.closing.geometry.dispose(); (this.full.material as THREE.Material).dispose(); (this.trail.material as THREE.Material).dispose(); (this.closing.material as THREE.Material).dispose(); }
}
